export default "__VITE_ASSET__DC4MEL2X__"